import { useState, useCallback } from 'react';
import { createPortal } from 'react-dom';
import { FiHelpCircle } from 'react-icons/fi';
import { useI18n } from '../i18n/useI18n';

export function AiScoreTooltip({ iconClassName = 'text-slate-500 text-xs' }) {
  const { t } = useI18n();
  const [showTooltip, setShowTooltip] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });

  const handleMouseEnter = useCallback((event) => {
    const rect = event.currentTarget.getBoundingClientRect();
    setTooltipPosition({
      x: rect.left + rect.width / 2,
      y: rect.top - 8
    });
    setShowTooltip(true);
  }, []);

  const handleMouseLeave = useCallback(() => {
    setShowTooltip(false);
  }, []);

  return (
    <>
      <span
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        className="inline-flex items-center"
      >
        <FiHelpCircle className={`cursor-help hover:text-slate-300 transition-colors ${iconClassName}`} />
      </span>

      {showTooltip && typeof document !== 'undefined' && createPortal(
        (
          <div
            className="fixed rounded-xl bg-slate-900 border border-slate-700 shadow-xl backdrop-blur-xl px-3 py-2 text-xs text-slate-200"
            style={{
              left: `${tooltipPosition.x}px`,
              top: `${tooltipPosition.y}px`,
              transform: 'translate(-50%, -100%)',
              zIndex: 9999
            }}
          >
            <div className="whitespace-nowrap">
              <span className="text-amber-300 font-medium">AI</span> {t('leaderboardTable.aiScore')}
            </div>
            <div className="text-slate-400 mt-1">{t('leaderboardTable.aiScoreHint')}</div>
          </div>
        ),
        document.body
      )}
    </>
  );
}
